<template>
  <div id="pdf-content">
    <div class="pdf-page-break invoice-page">
      <header class="invoice-header">
        <div class="invoice-title">
          <h1>INVOICE</h1>
          <div class="accent-line"></div>
        </div>

    
      </header>
      <section>
       
      </section>
      <section class="invoice-data">
        <div class="col-7 invoice-meta">
        <div class="">
          <div>Invoice number: {{ invoice.number }}</div>
          <div>Invoice date: {{ invoice.date }}</div>
        </div>
        <div class="bill-to">
          <strong>Invoice to:</strong>
          <div class="to-name">{{ invoice.to.name }}</div>
          <div class="to-address" v-html="formatAddress(invoice.to.address)"></div>
        </div>
        </div>
        <div class="col-5">
                 <div class="seller">
        
            <div v-for="(v, k) in invoice.from" :key="k" >
              <strong v-if="v">{{ k }}:</strong> {{ v }}
            </div>
         
        </div>
        </div>
    

      
      </section>

      <section class="invoice-lines">
        <table class="lines-table">
          <thead>
            <tr>
              <th class="col-date">Date</th>
              <th class="col-desc">Description</th>
              <th class="col-total">Total in EUR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in invoice.rows" :key="idx">
              <td class="col-date">{{ row.date }}</td>
              <td class="col-desc">{{ row.description }}</td>
              <td class="col-total">€ {{ row.total }}</td>
            </tr>
            <!-- fila visual final: barra gris que ocupa todo el ancho -->
            <tr class="final-row">
              <td colspan="3"></td>
            </tr>
          </tbody>
        </table>

        <aside class="totals-box">
          <div class="totals-row">
            <div>Subtotal in EUR</div>
            <div class="amount">€ {{ invoice.subtotal }}</div>
          </div>
          <div class="totals-row">
            <div>VAT (0.00%)</div>
            <div class="amount">€ {{ invoice.vat }}</div>
          </div>
          <hr />
          <div class="totals-row totals-grand">
            <div><strong>Total in EUR</strong></div>
            <div class="amount"><strong>€ {{ invoice.total }}</strong></div>
          </div>
        </aside>
      </section>

      <footer class="invoice-footer">
        <div class="notes" v-if="invoice.notes" v-html="invoice.notes"></div>
        <div class="legal">
          
          <p>
            The invoice was generated electronically and automatically, without a cash register.
            This is the original electronic version.
          </p>
          <p>Payment Date: {{ invoice.payment_date || invoice.date }}</p>
          <p>Payment method: {{ invoice.payment_method || 'Credit card' }}</p>
          <p>VAT information: {{ invoice.vat_info || 'TVA non applicable — art. 259-1 du CGI' }}</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookerInvoice",
  props: {
    invoice: {
      type: Object,
      default: () => ({
        number: 'N/A',
        date: '',
        to: { name: '', address: '' },
        from: { name: '', address: '', meta: null },
        rows: [],
        subtotal: '0.00',
        vat: '0.00',
        total: '0.00',
        notes: '',
        collection_id: null,
        payment_date: null,
        payment_method: null,
        vat_info: null
      })
    }
  },
  methods: {
    // convierte saltos de línea en <br> para mostrar direcciones multilínea en el pdf
    formatAddress(addr) {
      if (!addr) return '';
      return (addr + '').replace(/\n/g, '<br/>');
    }
  }
};
</script>

<style scoped>
.invoice-page {
  font-family: 'Times New Roman', Times, serif;
  color: #222;
  padding: 36px 48px;
  box-sizing: border-box;
  width: 210mm; /* A4 width for pdf rendering */
  min-height: 297mm;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
}

.invoice-title h1 {
  margin: 0;
  font-size: 34px;
  font-weight: 400;
  letter-spacing: 2px;
  color: #222;
}

.accent-line {
  height: 4px;
  width: 220px;
  background: linear-gradient(90deg, #f1e91f 0%, #d8d20f 100%);
  margin-top: 8px;
  border-radius: 2px;
}

.seller {
 display: flex;
 flex-direction: column;
 justify-content: flex-end;
  font-size: 11px;
  color: #333;
  max-width: 260px;
}

.seller-name {
  font-weight: 700;
  margin-bottom: 6px;
}
.invoice-data{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.invoice-meta {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 18px 0;
  font-size: 13px;
}

.bill-to {
  max-width: 60%;
}

.to-name {
  font-weight: 600;
  margin-top: 6px;
}

.meta-left {
  text-align: left;
  font-size: 13px;
}

.invoice-lines {
  position: relative;
  margin-top: 6px;
  padding-bottom: 18px;
}

/* tabla principal */
.lines-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: Arial, Helvetica, sans-serif; /* fuente más redondeada para la tabla */
}

/* header: amarillo sólido */
.lines-table thead th {
  text-align: left;
  padding: 12px 10px;
  background: #f5ec00;
  color: #222;
  font-weight: 700;
  font-family: "Arial Black", Gadget, sans-serif; /* encabezados con Arial Black */
  border-bottom: 1px solid rgba(0,0,0,0.06);
  font-size: 13px;
}

/* filas con alternancia gris / blanco (excluyendo la final-row) */
.lines-table tbody tr {
  vertical-align: middle;
  font-family: inherit;
  font-size: 13px;
}

/* excluir la final-row de la alternancia para que no se pise su fondo */
.lines-table tbody tr:not(.final-row):nth-child(odd) {
  background: #f6f6f6; /* gris claro */
}

.lines-table tbody tr:not(.final-row):nth-child(even) {
  background: #ffffff; /* blanco */
}

/* celdas: padding y borde sutil */
.lines-table tbody td {
  padding: 12px 10px;
  border-bottom: 1px solid #ececec;
  color: #333;
}

/* fila final: barra gris sin padding ni borde para imitar el diseño */
.lines-table tbody tr.final-row td {
  background: #f2f2f2 !important;
  height: 18px;     /* altura de la barra final */
  padding: 0 !important;       /* sin padding para que sea una franja */
  border-bottom: none !important;
  line-height: 0;
}

/* evitar que la fila anterior muestre borde inferior justo antes de la final-row */
.lines-table tbody tr:not(.final-row):last-child td {
  border-bottom: none;
}

/* ajustar anchos y alineado */
.col-date { width: 25%; }
.col-desc { width: 55%; }
.col-total { width: 20%; text-align: right; }

/* si necesitas que la última fila no tenga borde inferior (opcional) */
.lines-table tbody tr:last-child td {
  border-bottom: none;
}

/* cuadro de totales */
.totals-box {
  position: absolute;
  right: 0;
  top: 320px;
  width: 300px;
  border: 1px solid #ddd;
  padding: 12px;
  background: #fff;
  box-sizing: border-box;
  font-size: 13px;
}

.totals-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
}

.totals-row + .totals-row { border-top: 1px solid transparent; }

.totals-grand {
  margin-top: 6px;
  padding-top: 6px;
}

.amount {
  min-width: 90px;
  text-align: right;
}

/* footer texto pequeño */
.invoice-footer {
  margin-top: 360px;
  color: #777;
  font-size: 11px;
  line-height: 1.4;
}

.invoice-footer .notes {
  margin-bottom: 12px;
  color: #555;
}

/* asegurar que elementos no se desplacen fuera en la generación */
.pdf-page-break {
  page-break-after: always;
}
</style>
